import * as _ from '../vendor/lodash'
import * as net from './net'
import render from './render'
import * as route from './route'
import * as propUtil from './prop-util'

const inFlightSearches = new Map()

export function handleSubmit (e) {
  e.preventDefault()
  const query = e.target.querySelector('input[name=search]').value
  route.redirect(`/app/search/${encodeURIComponent(query)}`)
}

export function handleSearch (e) {
  e.preventDefault()
  if (e.target.value === '') {
    route.redirect('/app/search')
  }
}

export function execute (query) {
  if (!query) return route.redirect('/app/search')
  if (inFlightSearches.has(query)) return inFlightSearches.get(query)

  // The loading screen just won't display otherwise, even with forceUpdate
  _.defer(() => render(propUtil.replace(['searches', query], 'loading')))

  const request = net.get(`/api/item_searches/${encodeURIComponent(query)}`, {
    suppressErrorNotification: true,
    onFailure ({ error, response }) {
      const retryAfterMilliseconds = net.retryAfterMilliseconds(response)
      inFlightSearches.delete(query)
      render(propUtil.replace(['searches', query], {
        errorMessage: error.message,
        retryAt: Date.now() + retryAfterMilliseconds
      }))
      if (retryAfterMilliseconds > 0) {
        setTimeout(() => render(propUtil.merge()), retryAfterMilliseconds)
      }
    }
  })
  inFlightSearches.set(query, request)
  request.then(res => {
    render(propUtil.replace(['searches', query], res))
  }).finally(() => {
    if (inFlightSearches.get(query) === request) inFlightSearches.delete(query)
  })
  return request
}
